import face from "../../images/photos/face.jpeg";

function AboutSection() {

    return (
        <section>
            <div className="section-side-2">
                <img src={face} alt="marc" />
            </div>
            <div className="section-side-1">
                <h3>About Me</h3>
                <div className="paragraph justify">
                    I am a trained Integrative Transpersonal Psychotherapist. Compassionate and person-centered
                    psychotherapist dedicated to creating a safe and supportive space where individuals can explore
                    their experiences, develop insight, and foster resilience. My approach integrates evidence-based
                    practices with genuine empathy, tailoring each session to the unique needs and goals of my clients.
                    I believe in the power of the therapeutic relationship as a catalyst for growth, healing, and
                    lasting change, and I am committed to walking alongside my clients as they navigate challenges
                    and discover their own strengths.
                </div>
                <div className="paragraph justify">
                    I believe that everyone deserves a safe space to be heard, understood, and supported. My style
                    is warm and collaborative—I’ll meet you where you are and walk alongside you as we explore the
                    challenges you’re facing. Together, we’ll work on building insight, finding new ways of coping,
                    and uncovering your strengths so you can move towards the life you want.
                </div>
                <div className="paragraph justify">
                    I know finding a therapist can feel daunting and just taking the first step can be hard. But
                    if you're going through difficult times, I hope you will reach out. I offer therapy in English
                    and in French. Please feel free to contact me for a free 20-minute video or telephone call to
                    explore how we might work together and address any questions you may have.
                </div>
            </div>
        </section>
    );
}

export default AboutSection;

// https://www.youtube.com/watch?v=YOAeBSCkArA